<template>
    <v-container>
        <v-row>
            <v-col>
                <v-card>
                    <v-card-title class="primary">
                        <v-toolbar-title style="color: white;">
                            Procesar Reporte Pago
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-icon color="white">mdi-file-document-multiple-outline</v-icon>
                    </v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col>
                                <v-data-table :headers="header2"
                                              item-key="nrreporte"
                                              :loading="show"
                                              loading-text="Cargando... espere un momento"
                                              no-data-text="No hay datos disponibles"
                                              :items="docto"
                                              :footer-props="{
                                                  'items-per-page-options': [20, 50, 100],
                                                  'items-per-page-text':'Registros por página'
                                                }">
                                    <template v-slot:item.actions="{ item }">
                                        
                                        <v-btn color="primary"
                                               v-on:click="ProcesarReporte(item)"
                                               small
                                               fab
                                               dark>
                                            <v-icon>
                                                mdi-file-restore-outline
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                </v-data-table>
                            </v-col>
                        </v-row>
                       
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
    import servicio from '@/services/TramitePago/TramitePago.Service.js';
    import MetodosGenerales from '@/utils/metodosgenerales.vue.js';
    import { mapActions, mapState } from 'vuex';
    export default {
        title() {
            return this.$route.meta.title
        },
        data: function () {
            return {
                docto: [],
                show: true,
                Recibir:[],
                header2: [
                    { text: 'Reporte', value: 'nrreporte', class: 'text title' },
                    { text: 'Abogado', value: 'prnombre', class: 'text title' },
                    { text: 'Asistencia', value: 'Asistencia', class: "text title" },
                    { text: 'Cliente', value: 'Cliente', class: "text title" },
                    { text: 'Fecha del Reporte', value: 'svfhreporte', class: "text title" },
                    { text: 'Fecha Cerrado', value: 'svfhconclusion', class: "text title" },
                    { text: '', value: 'actions', sortable: false },
                ],
                disabledCount: 0,
                uslogin: 'nlarap',
            }
        },
        props:['Reportes'],
        computed: {
            ...mapState([
                "domain",
                "informationPage",
                "paginacion",
                "permission",
                "user"
            ])
        },
        methods: {
            async ObtenerDocumentos() {
                let formdata = new FormData();
                formdata.append("permiso", 339);
                await servicio.ReportesPendienteValidar(this, formdata).then(data => {
                    this.show = false;
                    this.docto = data;
                });
            },
            RecibirDocto() {
                if (this.Recibir.length > 0) {
                    this.$router.push({ name: `RecibirReporte`, params: { docto: this.Recibir } });
                }
                else {
                    this.$swal({
                        position: 'center',
                        icon: 'warning',
                        title: 'Debe seleccionar al menos un reporte para su Tramite',
                        showConfirmButton: true,
                        confirmButtonText: 'Aceptar',
                        timer: 2000,
                    });
                }

            },
            clearTabla() {
                this.Recibir = [];
            },
            async ProcesarReporte(item) {
                let aux = item.nrreporte.split('-');
                let _svindice = aux[1];
                let _nrreporte = aux[0];

                let reporte = {
                    nrreporte: _nrreporte,
                    svindice: _svindice,
                    aiclave: item.aiclave,
                    svfhconclusion: item.svfhconclusion
                };
                await MetodosGenerales.guardarEnSesionInfoReporte(reporte, 'reporte');
                this.$router.push({ name: `ProcesoPago` });
            },

            selectAllToggle(props) {
                if (this.Recibir.length != this.docto.length - this.disabledCount) {
                    this.Recibir = [];
                    const self = this;
                    props.items.forEach(item => {
                        if (item.tpestatus == 52 && item.uslogin != 'agutierrezc') {
                            self.Recibir.push(item);
                        }
                        if (item.tpestatus == 55 && item.uslogin == 'agutierrezc') {
                            self.Recibir.push(item);
                        }
                    });
                } else this.Recibir = [];
            }
        },
        mounted() {
        },
        async created() {
            await this.ObtenerDocumentos();
            const self = this;
            this.docto.map(item => {
                if (item.tpestatus == 55 && item.uslogin != 'agutierrezc') self.disabledCount += 1
                if (item.tpestatus == 56 && item.uslogin == 'agutierrezc') self.disabledCount += 1
            });
        }
    }
</script>